// src/pages/admin/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('¡Bienvenida, Wawita! 🌿');
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'linear-gradient(135deg, var(--forest) 0%, var(--green-mid) 100%)',
      padding:20
    }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ fontSize:56, marginBottom:12 }}>🌿</div>
          <h1 style={{ fontFamily:'var(--font-display)', color:'#b8e07a', fontSize:32, fontWeight:700 }}>Wawita</h1>
          <p style={{ color:'rgba(255,255,255,0.5)', fontSize:14, marginTop:4 }}>Panel Administrativo</p>
        </div>

        {/* Form */}
        <div className="card" style={{ padding:32 }}>
          <h2 style={{ fontSize:20, fontWeight:800, marginBottom:24, textAlign:'center', color:'var(--forest)' }}>Iniciar sesión</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Correo electrónico</label>
              <input className="form-input" type="email" placeholder="admin@wawitaeco.com"
                value={form.email} onChange={e => setForm(f => ({...f, email: e.target.value}))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Contraseña</label>
              <input className="form-input" type="password" placeholder="••••••••"
                value={form.password} onChange={e => setForm(f => ({...f, password: e.target.value}))} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width:'100%', marginTop:8, padding:'12px' }} disabled={loading}>
              {loading ? <><span className="spinner" style={{width:16,height:16}} /> Ingresando...</> : '🌿 Ingresar'}
            </button>
          </form>
          <div style={{ textAlign:'center', marginTop:16, fontSize:13, color:'var(--text-muted)' }}>
            <a href="/" style={{ color:'var(--green)', fontWeight:700 }}>Ver tienda publica</a>
          </div>
        </div>

        {/* Setup hint */}
        <div style={{ marginTop:16, background:'rgba(255,255,255,0.07)', borderRadius:10, padding:'12px 16px', color:'rgba(255,255,255,0.45)', fontSize:12, lineHeight:1.6 }}>
          <strong style={{ color:'rgba(255,255,255,0.6)' }}>Primera vez:</strong> Crea tu admin en:<br/>
          <code style={{ color:'#b8e07a', fontSize:11 }}>POST /api/auth/register-admin</code><br/>
          con tu nombre, email, contraseña y <code style={{ color:'#b8e07a' }}>secreto: "wawita2024setup"</code>
        </div>
      </div>
    </div>
  );
}
